var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g({staticClass:"v-input",class:{ 'v-input--error': _vm.error },domProps:{"value":_vm.value}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }